import { SiteFooter } from "@/components/SiteFooter";
import { CONTACT_EMAIL } from "@/lib/contact";
import { ContactForm } from "@/components/ContactForm";

/*
 * What happens after the form, said plainly.
 *
 * A contact page's real job is not collecting an address, it is removing the
 * reason somebody hesitates before sending one. On a page selling an
 * independent opinion the hesitation is always the same — what am I actually
 * committing to — so the answer sits beside the form rather than under it.
 */
const STEPS = [
  {
    n: "01",
    title: "We read it",
    body: "A person, not a queue. If it is not something we should take on, we will say so and point you somewhere better.",
  },
  {
    n: "02",
    title: "We scope the hour",
    body: "A short reply agreeing what gets looked at, so the hour is spent reviewing rather than working out what to review.",
  },
  {
    n: "03",
    title: "You get the verdict",
    body: "What we found, how bad it is, and what we would do first. No obligation past the hour.",
  },
] as const;

export function Contact() {
  return (
    <main>
      <section className="k-shell k-contact">
        <div>
          <p className="k-eyebrow">New case file · Intake</p>
          <h1>
            Tell us what to <span className="k-mark">look at.</span>
          </h1>
          <p className="k-lede">
            One diagnostic hour, $125, no retainer and no lock-in. Or email{" "}
            <a className="k-link" href={`mailto:${CONTACT_EMAIL}`}>
              {CONTACT_EMAIL}
            </a>{" "}
            if a form is not your thing.
          </p>

          <ContactForm />
        </div>

        {/*
          The same case-file furniture as the hero on the home page — dashed
          tear-off rule, monospaced header — so the intake reads as the front
          of the document the review produces rather than as a generic form
          page bolted on the side.
        */}
        <aside className="k-stage">
          <div className="k-file">
            <div className="k-file__head k-file__head--plain">
              <span className="k-file__ref">Procedure · What happens next</span>
            </div>
            <div className="k-file__body">
              {STEPS.map((step) => (
                <div key={step.n} className="k-next">
                  <span className="k-next__n">{step.n}</span>
                  <div>
                    <h3>{step.title}</h3>
                    <p>{step.body}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="k-file__foot">
              <div className="k-file__line">
                <b>One diagnostic hour</b>
                <span className="k-file__price">$125</span>
              </div>
            </div>
          </div>
        </aside>
      </section>

      <SiteFooter />
    </main>
  );
}
